'use client';

import { BaseMarketingSection } from '@/components/organisms';
import { BaseMarketingSectionSkeleton } from '@/components/organisms/skeletons/BaseMarketingSectionSkeleton';
import { useMarketingInfoQuery } from '@/hooks/league/useMarketingInfoQuery';

export const AssociationsSection = () => {
	const { data: associationsInfo, isFetching } = useMarketingInfoQuery('2');
	const modules = associationsInfo?.data?.modules;

	if (!associationsInfo?.data?.modules) return null;

	if (isFetching) {
		return <BaseMarketingSectionSkeleton />;
	}
	if (!modules || modules.length === 0) {
		return null;
	}

	return <BaseMarketingSection marketingData={modules ?? []} marketingTitle="Associations" />;
};
